// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.games-we-offer-section {
  padding: 4rem 0;
  margin: 0 auto;
}
.games-we-offer-section .games-we-offer-wrap {
  width: 100%;
  max-width: var(--containerWidth);
  margin: 0 auto;
}
.games-we-offer-section .games-we-offer-wrap .games-we-offer-box .games-grid-box {
  --grid-column-number: 5;
  --grid-gap: 2rem;
  width: 100%;
  max-width: 65.875rem;
  display: grid;
  grid-template-columns: repeat(var(--grid-column-number), 1fr);
  gap: var(--grid-gap);
  margin: 4rem auto;
}
.games-we-offer-section .games-we-offer-wrap .games-we-offer-box .btn-box {
  display: flex;
  justify-content: center;
  margin-top: 4rem;
}
@media screen and (max-width: 991.98px) {
  .games-we-offer-section {
    padding: 2.5rem 0;
  }
  .games-we-offer-section .games-we-offer-wrap .games-we-offer-box .games-grid-box {
    --grid-column-number: 5;
    --grid-gap: 1rem;
    margin: 2.5rem 0;
  }
  .games-we-offer-section .games-we-offer-wrap .games-we-offer-box .btn-box {
    margin-top: 2.5rem;
  }
}
@media screen and (max-width: 767.98px) {
  .games-we-offer-section {
    padding: 2rem 0;
  }
  .games-we-offer-section .games-we-offer-wrap .games-we-offer-box .games-grid-box {
    --grid-column-number: 4;
    --grid-gap: 1rem;
    margin: 2rem 0;
  }
  .games-we-offer-section .games-we-offer-wrap .games-we-offer-box .btn-box {
    margin-top: 1.25rem;
  }
}
@media screen and (max-width: 639.98px) {
  .games-we-offer-section {
    padding: 2rem 0;
  }
  .games-we-offer-section .games-we-offer-wrap .games-we-offer-box .games-grid-box {
    --grid-column-number: 3;
  }
}
@media screen and (max-width: 474.98px) {
  .games-we-offer-section {
    padding: 2rem 0;
  }
  .games-we-offer-section .games-we-offer-wrap .games-we-offer-box .games-grid-box {
    --grid-column-number: 2;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/GamesWeOfferSection/GamesWeOfferStyle.scss"],"names":[],"mappings":"AAAA;EACE,eAAA;EACA,cAAA;AACF;AACE;EACE,WAAA;EACA,gCAAA;EACA,cAAA;AACJ;AAEM;EACE,uBAAA;EACA,gBAAA;EACA,WAAA;EACA,oBAAA;EACA,aAAA;EACA,6DAAA;EACA,oBAAA;EACA,iBAAA;AAAR;AAGM;EACE,aAAA;EACA,uBAAA;EACA,gBAAA;AADR;AAME;EA7BF;IA8BI,iBAAA;EAHF;EAOM;IACE,uBAAA;IACA,gBAAA;IACA,gBAAA;EALR;EAQM;IACE,kBAAA;EANR;AACF;AAWE;EA/CF;IAgDI,eAAA;EARF;EAYM;IACE,uBAAA;IACA,gBAAA;IACA,cAAA;EAVR;EAaM;IACE,mBAAA;EAXR;AACF;AAgBE;EAjEF;IAkEI,eAAA;EAbF;EAiBM;IACE,uBAAA;EAfR;AACF;AAoBE;EA7EF;IA8EI,eAAA;EAjBF;EAqBM;IACE,uBAAA;EAnBR;AACF","sourcesContent":[".games-we-offer-section {\n  padding: 4rem 0;\n  margin: 0 auto;\n\n  .games-we-offer-wrap {\n    width: 100%;\n    max-width: var(--containerWidth);\n    margin: 0 auto;\n\n    .games-we-offer-box {\n      .games-grid-box {\n        --grid-column-number: 5;\n        --grid-gap: 2rem;\n        width: 100%;\n        max-width: 65.875rem;\n        display: grid;\n        grid-template-columns: repeat(var(--grid-column-number), 1fr);\n        gap: var(--grid-gap);\n        margin: 4rem auto;\n      }\n\n      .btn-box {\n        display: flex;\n        justify-content: center;\n        margin-top: 4rem;\n      }\n    }\n  }\n\n  @media screen and (max-width: 991.98px) {\n    padding: 2.5rem 0;\n\n    .games-we-offer-wrap {  \n      .games-we-offer-box {\n        .games-grid-box {\n          --grid-column-number: 5;\n          --grid-gap: 1rem;\n          margin: 2.5rem 0;\n        }\n  \n        .btn-box {\n          margin-top: 2.5rem;\n        }\n      }\n    }\n  }\n  \n  @media screen and (max-width: 767.98px) {\n    padding: 2rem 0;\n\n    .games-we-offer-wrap {  \n      .games-we-offer-box {\n        .games-grid-box {\n          --grid-column-number: 4;\n          --grid-gap: 1rem;\n          margin: 2rem 0;\n        }\n  \n        .btn-box {\n          margin-top: 1.25rem;\n        }\n      }\n    }\n  }\n  \n  @media screen and (max-width: 639.98px) {\n    padding: 2rem 0;\n\n    .games-we-offer-wrap {  \n      .games-we-offer-box {\n        .games-grid-box {\n          --grid-column-number: 3;\n        }\n      }\n    }\n  }\n\n  @media screen and (max-width: 474.98px) {\n    padding: 2rem 0;\n\n    .games-we-offer-wrap {  \n      .games-we-offer-box {\n        .games-grid-box {\n          --grid-column-number: 2;\n        }\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
